<template>
  <div class="row" id="users">
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :apiURL="apiURL"
        :readonly="true"
        title="Movimientos"
        :queryParams="queryParams"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('movement') };
  },
  data: () => ({
    headers: [
      {
        text: 'Tipo',
        value: 'tipo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Descripción',
        value: 'descripcion',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha',
        value: 'created_at',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Usuario',
        value: 'user',
        align: 'left',
        sortable: true,
      },
    ],
    items: [],
    totalItems: 0,
    typePortal: 'D',
    apiURL: '/api/transactions',
  }),
  computed: {
    queryParams() {
      return `&dealer=${this.user.dealer_id}&typePortal=${this.typePortal}`;
    },
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  components: {
    VuetifyTable,
  },
};
</script>
